import React from 'react'
import Modal from '@mui/material/Modal'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close';
import { Client, User, Product, Level, Category, Room, SignOut, Reservation } from './forms/index';
import { InvalidDate, LoginError } from './notifications/index';
import theme from '../assets/theme';
import { useDispatch } from 'react-redux';
import { modalAction, modalDeleteAction } from '../redux/reducers/Modal';
import { UseScreen } from '../hooks/UseScreen.hook';

const DangerModal = (props) => {

    const screenWidth = UseScreen();
    const [ style, setStyle ] = React.useState({});

    React.useEffect( () => {
        const modalStyle = () => {
            if( screenWidth <= 500 ){
                return {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    bgcolor: 'secondary.main',
                    boxShadow: 24,
                    borderRadius: '.8rem',
                    p: 4,
                    color: '#FFF'
                }
            }else{
                return {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '60%',
                    bgcolor: 'secondary.main',
                    boxShadow: 24,
                    borderRadius: '.8rem',
                    p: 4,
                    color: '#FFF'
                }
            }
        }

        setStyle(modalStyle());
    },[] )

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const dispatch = useDispatch();

    const viewDetails = () => {
        switch(props.view){
            case 'client': 
                return <Client />;
            case 'user': 
                return <User />;
            case 'product': 
                return <Product />;
            case 'level': 
                return <Level />;
            case 'category': 
                return <Category />;
            case 'room': 
                return <Room />;
            case 'signOut': 
                return <SignOut />;
            case 'invalidDate':
                return <InvalidDate />
            case 'errorLogin':
                return <LoginError />
            case 'deleteReservation':
                return <Reservation />
            default: return null;
        }
    }

  return (
    <>
        <Modal
            open={true}
            onClose={ () => dispatch(modalDeleteAction()) }
        >
            <Grid container sx={style}>
                <Grid item xs={ 12 } textAlign='end'>
                    <IconButton align='end' style={{ backgroundColor: '#EEE', width: '1rem', height: '1rem' }} onClick={ () => dispatch(modalDeleteAction()) }>
                        <CloseIcon style={{ color: '#000', width: '.8rem' }} align='end' />
                    </IconButton>
                </Grid>
                {
                    viewDetails()
                }
            </Grid>
        </Modal>
    </>
  )
}

export default DangerModal